import { createCache } from 'cross-state';

createCache.defaultOptions = {
  ...createCache.defaultOptions,
  invalidateAfter: { minutes: 10 },
};
